var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{style:(_vm.buttonStyle),attrs:{"title":_vm.isIcon ? _vm.title : '',"icon":_vm.getIconClass(_vm.ThemeConfig.Icon),"plain":_vm.isPlain,"type":_vm.isLink ? 'text' : _vm.buttonType || _vm.ThemeConfig.ButtonType,"loading":_vm.loading,"size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }